import React, { Component } from 'react';
import { Modal, message } from 'antd';
import API_URL from '../../../../common/url';
import $ from "../../../../common/AjaxRequest";
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';

const SortableItem = SortableElement(({ value }) =>
    <div className="sort-wrap">
        <div className="sort-item" style={{ width: '100%' }}>
            {value.typeName}
        </div>
    </div>
);

const SortableList = SortableContainer(({ data }) => {
    return (
        <div className='degreesort'>
            {data.map((item, index) => (
                <SortableItem key={`item-${index}`} index={index} value={item} />
            ))}
        </div>
    );
});

const Config = {
    'ServiceQuotationDetail': {
        url: API_URL.evaluate.sortFteSimpleData,
        idName: 'quotationFteRowId',
    },
    'SimpleQuotation': {
        url: API_URL.evaluate.sortVisitSimpleData,
        idName: 'quotationVisitRowId',
    },
    'DetailedQuotation': {
        url: API_URL.evaluate.sortVisitDetailData,
        idName: 'quotationVisitRowId',
    },
}

class DetailSortModal extends Component {
    state = {
        visible: false,
        dataType: '',
        data: [],
    }

    onSortEnd = ({ oldIndex, newIndex }) => {
        const { data } = this.state;
        this.setState({
            data: arrayMove(data, oldIndex, newIndex),
        });
    }

    show = (data, activeKey) => {
        const { key, rowDatas } = (data || {});
        const { idName } = Config[activeKey];
        this.setState({
            visible: true,
            dataType: key,
            activeKey,
            data: (rowDatas || []).filter(el => el[idName]),
        });
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    }

    confirm = () => {
        const { data, dataType, activeKey } = this.state;
        const { clinicalQuotationRecordId, loadData } = this.props;
        const { url, idName } = Config[activeKey];
        let sendData = {};  //存放传给后台内容的对象
        data.map((el, index) => {  
            sendData[`rowDatas[${index}].${idName}`] = el[idName];
        });
        const options = {
            method: 'POST',
            url,
            data: { 
                dataType,
                ...sendData,
                clinicalQuotationRecordId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success('排序成功');
                this.hide();
                loadData(clinicalQuotationRecordId, activeKey);
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { data, visible, loading } = this.state;
        return (
            <Modal
                title="调整顺序"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="create-modal"
                maskClosable={false}
                width="500px"
                confirmLoading={loading}
            >
                <div>
                    <SortableList data={data} axis="xy" helperClass="sortHelper" onSortEnd={this.onSortEnd} />
                </div>
            </Modal>
        );
    }
}

export default DetailSortModal;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/DetailSortModal.js